export default __webpack_public_path__ + "f4b625df58853620a2f2f42b7e380698.png";